export default __webpack_public_path__ + "mini-icon-android-15@2x.png";